import React from 'react';
import { connect } from 'react-redux';
import VideoPlayerHandler from './VideoPlayerHandler.js';
import {
    autoPlaySelector,
    parentalLockSelector,
    videoCompatibilityModeSelector,
} from '../../../reducers/settings';
import { nextVideoIsBingeSelector, parentalLockConfirmedSelector } from '../../../reducers/videoPage';
import {
    continueWatchingPositionForVideo,
    continueWatchingActiveSelector,
} from '../../../reducers/continueWatching';
import { updateAccessVersionChoice } from 'app/actions/videoPage/index.js';

const VideoPlayerHandlerContainer = (props) => {
    return <VideoPlayerHandler {...props} />;
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        autoPlayEnabled: autoPlaySelector(state),
        parentalLockEnabled: parentalLockSelector(state),
        continueWatchingEnabled: continueWatchingActiveSelector(state),
        parentalLockConfirmed: parentalLockConfirmedSelector(state),
        nextVideoIsBinge: nextVideoIsBingeSelector(state),
        startPosition: continueWatchingPositionForVideo(state, ownProps.visionId),
        useVideoCompatibilityMode: videoCompatibilityModeSelector(state),
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateAccessibilityVersion: (variant) => dispatch(updateAccessVersionChoice(variant)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(VideoPlayerHandlerContainer);
